<template>
  <img :src="source" :alt="$gettext('AI-generated')" class="ai-generated-label" :class="variant" />
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

// Official EU labelling shapes; the wording is part of the artwork and therefore not translatable.
const SOURCES: Record<string, string> = {
  round: '/static/img/default/LABEL_AI_black.svg',
  pill: '/static/img/default/LABEL_AI_GENERATED_black.svg',
}

@Component({
  name: 'ai-generated-label',
})
export default class AiGeneratedLabel extends Vue {
  @Prop({ required: true }) variant!: 'round' | 'pill'

  get source(): string {
    return SOURCES[this.variant]
  }
}
</script>

<style scoped>
.ai-generated-label {
  display: block;
}

.ai-generated-label.round {
  width: 38px;
  height: 38px;
}

.ai-generated-label.pill {
  width: 107px;
  height: 34px;
}
</style>
